import { hubSpotConnectRedirect } from './productLinks';
export const getConnectFlowRedirect = () => {
  return hubSpotConnectRedirect();
};